import { usersArray } from "assets/data/usersData";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Button, Member, UsersPagesHeader } from "ui";

const FollowingPage = () => {
    const [filter, setFilter] = useState("");
    const following = usersArray.filter((member, i) => {
        if (i % 3) {
            return member;
        }
    });
    return (
        <FeedLayout pageTitle="">
            <UsersPagesHeader
                active="Following"
                filterValue={filter}
                setFilterValue={setFilter}
            >
                <div
                    className={`profile-followers-container pt-20 pl-20 pr-20 pb-20 d-flex flex-col flex-j-between`}
                >
                    <div>
                        {following.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                                isFollowed
                            />
                        ))}
                    </div>
                    <div className="mb-10 d-flex flex-j-center w-full">
                        <Button text="show More" color="" rounded />
                    </div>
                </div>
            </UsersPagesHeader>
        </FeedLayout>
    );
};

export default FollowingPage;
